import Swiper from "swiper";
import { A11y, Autoplay, EffectFade, Navigation, Pagination, Scrollbar } from "swiper/modules";
import "@/styles/components/slider.css";
import { fireEvent } from "@/scripts/common/util";

export default {
  init: () => {
    document.querySelectorAll(".media-slider").forEach((el) => {
      const container = el.querySelector(".swiper");
      const sliderNavigation = el.querySelector(".slider-navigation");
      const sliderScrollbar = el.querySelector(".swiper-scrollbar");
      const sliderPagination = el.querySelector(".slider-pagination");
      const asMultipleVideos = el.querySelectorAll(".media-item.as-video").length > 1;
      const numSlides = el.querySelectorAll(".swiper-slide");

      if (!container) {
        return;
      }

      const opts = {
        modules: [A11y, Autoplay, EffectFade, Navigation, Pagination, Scrollbar],
        effect: "fade",
        fadeEffect: {
          crossFade: true,
        },
        loop: numSlides > 1,
        speed: 800,
      };

      if (!asMultipleVideos) {
        opts.autoplay = {
          delay: 4000,
          pauseOnMouseEnter: true,
        };
      }

      if (sliderNavigation) {
        opts.navigation = {
          nextEl: el.querySelector(".slider-button-next"),
          prevEl: el.querySelector(".slider-button-prev"),
        };
      }

      if (sliderPagination) {
        opts.pagination = {
          el: sliderPagination,
          clickable: true,
        };
      }

      if (sliderScrollbar) {
        opts.scrollbar = {
          el: sliderScrollbar,
          draggable: true,
        };
      }

      const swiper = new Swiper(container, opts);

      if (asMultipleVideos) {
        container.querySelectorAll(".media-item.as-video video").forEach((video) => {
          video.loop = false;
          video.addEventListener("ended", () => {
            swiper.slideNext();
          });
        });

        swiper.on("slideChange", () => {
          const activeSlide = swiper.slides[swiper.activeIndex];
          activeSlide.querySelector("video").play();
        });
      } else {
        swiper.autoplay.stop();

        if (el.closest("[data-media-slider-listener]")) {
          swiper.on("slideChange", () => {
            fireEvent("slide:change", el.closest("[data-media-slider-listener]"), { index: swiper.activeIndex });
          });
        }
      }

      const start = () => {
        if (asMultipleVideos) {
          const activeSlide = swiper.slides[swiper.activeIndex];
          activeSlide.querySelector("video").play();
        } else {
          swiper.autoplay.start();
        }
      };

      const observer = new IntersectionObserver(
        ([e]) => {
          if (e.isIntersecting) {
            start();
            observer.disconnect();
          }
        },
        {
          threshold: [0.7],
        },
      );

      observer.observe(el);
    });

    document.querySelectorAll(".media-block").forEach((el) => {
      const asMultipleVideos = el.querySelectorAll(".media-item.as-video").length > 1;

      if (!asMultipleVideos) {
        el.querySelectorAll("video").forEach((video) => {
          const observer = new IntersectionObserver(
            async ([e]) => {
              if (e.isIntersecting) {
                try {
                  await video.play();
                } catch (err) {
                  console.error(err);
                }
                observer.disconnect();
              }
            },
            {
              threshold: [0.7],
            },
          );

          observer.observe(el);
        });
      }
    });
  },
};
